export const getBidOnlinePaymentPromptPriceContainerStyle = (theme) => ({
    width: '285px',
    marginLeft: 'auto',
    marginRight: 'auto'
});

export const getBidOnlinePaymentPromptPriceTitleStyle = (theme) => ({
    float: 'left',
    width: '140px',
    textAlign: 'left'
});

export const getBidOnlinePaymentPromptPriceValueStyle = (theme) => ({
    float: 'left',
    width: '140px',
    textAlign: 'right'
});